import { createContext, useContext } from "react";
import { Store } from "./Store";

const StoreContext = createContext(new Store());
export const useStore = () => useContext(StoreContext);
